import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../../components/Icon/Icon.styles';
import { buttonResetMixin } from '../buttonResetMixin';
export var TagCloseButtonMixin = function TagCloseButtonMixin(props) {
  return token({
    focusBoxShadow: 'Tag.closeButton.boxShadow.focus',
    hoverOpacity: 'Tag.closeButton.opacity.hover',
    activeOpacity: 'Tag.closeButton.opacity.active',
    targetPadding: 'Tag.targetPadding',
    borderRadius: 'Tag.closeButton.borderRadius',
    lineHeight: 'Tag.closeButtonSize'
  }, function (_ref) {
    var focusBoxShadow = _ref.focusBoxShadow,
      hoverOpacity = _ref.hoverOpacity,
      activeOpacity = _ref.activeOpacity,
      targetPadding = _ref.targetPadding,
      borderRadius = _ref.borderRadius,
      lineHeight = _ref.lineHeight;
    return css(["", " padding:", "px;margin:-", "px;line-height:", "px;transition:opacity 0.15s ease;&:hover{opacity:", ";}&:active{opacity:", ";}outline:none;&:focus ", "{border-radius:", ";box-shadow:", ";}"], buttonResetMixin(props), targetPadding, targetPadding, lineHeight, hoverOpacity, activeOpacity, StyledIcon, borderRadius, focusBoxShadow);
  })(props);
};